// NEW: UI_REVAMP
import { Box, Button, CircularProgress } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useRef, useState } from 'react';
import { getCreditRemainApi } from '../../api/query/profileApi';
import ImgComp from '../../utils/ImgComp';
import PriceText from '../betting/PriceText';

const BalancePill = () => {
	const isSeamless = sessionStorage.getItem('isSeamless');
	const balanceSyncInterval = sessionStorage.getItem('balanceSyncInterval');

	const [isLoading, setIsLoading] = useState(false);

	const getCreditRemain = useQuery(['getCreditRemainApi'], getCreditRemainApi, {
		enabled: false,
	});

	const handleReloadCredit = () => {
		setIsLoading(true);
		getCreditRemain.refetch();
		setTimeout(() => setIsLoading(false), 300);
	};

	const refreshSeamlessBalance = () => {
		setIsLoading(true);
		getCreditRemain.refetch();
		setTimeout(() => setIsLoading(false), 300);
	};

	const intervalRef = useRef(null);

	useEffect(() => {
		if (isSeamless === 'true') {
			intervalRef.current = setInterval(() => {
				refreshSeamlessBalance();
			}, balanceSyncInterval);
		}

		return () => clearInterval(intervalRef.current);
	}, []);

	return (
		<Box
			display='flex'
			alignItems='center'
			bgGradient='linear-gradient(180deg, #8CB3F5 0%, #0A54EF 100%)'
			gap={1}
			p={2}
			borderRadius='full'
			h={{ base: '32px', lg: '30px' }}
		>
			<ImgComp svgName='coin' size='12px' />

			<PriceText
				price={
					getCreditRemain.data?.creditRemain === undefined ? 0 : getCreditRemain.data.creditRemain
				}
			/>

			<Button
				bg='white'
				borderRadius='full'
				h={3}
				w={3}
				minW={0}
				p={0}
				display='flex'
				alignItems='center'
				justifyContent='center'
				onClick={handleReloadCredit}
				cursor='pointer'
				userSelect='none'
				_hover={{ bg: 'white' }}
			>
				{isLoading ? (
					<CircularProgress isIndeterminate color='blue.600' size='7px' />
				) : (
					<ImgComp svgName='refresh' width='7px' height='auto' />
				)}
			</Button>
		</Box>
	);
};

export default BalancePill;
